import { ToggleButton, ToggleButtonItem } from '@apply/components';
import React from 'react';
import { DashboardOutstandingByMonthPivotMode } from '../../../../../../constants/DashboardOutstandingByMonthPivotMode';

export const DashboardOutstandingByMonthPivotToggleButton: React.FC<{
    pivotMode: DashboardOutstandingByMonthPivotMode;
    set_pivotMode: (mode: DashboardOutstandingByMonthPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    const pivotModes: ToggleButtonItem[] = [
        {
            id: DashboardOutstandingByMonthPivotMode.Committed,
            text: 'Commitments',
            hint: 'Display Committed Amounts',
        },
        {
            id: DashboardOutstandingByMonthPivotMode.Funded,
            text: 'Funded',
            hint: 'Display Funded Amounts',
        },
        {
            id: DashboardOutstandingByMonthPivotMode.Number,
            text: 'Number',
            hint: 'Display the Number of Closed Loans',
        },
    ];
    return (
        <ToggleButton
            id='dashboardClosedbyMonthPivotToggleButton'
            items={pivotModes}
            selectedItems={[pivotMode]}
            stylingMode='outlined'
            selectionMode='single'
            onItemClick={(e) => set_pivotMode(e?.itemData.id)}
            width='270px'
            height='24px'
            required={true}
        />
    );
};
